import React, { useState } from "react";
import useWindowDimensions from "../get-diemensions/UseWindowDiemensions";
import {
  ContactUsPopUp,
  LoginPopUp,
  MenuDisplayHeader,
  SignUpPopUp,
} from "../components";
import { colors } from "../themes/Colors";
import { useNavigate } from "react-router-dom";
import {
  Footer,
  InfoPanel,
  MainBanner,
  NearStore,
  Welcome,
} from "./components";

const LandingPage = () => {
  const { width, height } = useWindowDimensions();
  const navigate = useNavigate();
  const [signUp, setSignUp] = useState(false);
  const [login, setLogin] = useState(false);
  const [contact, setContact] = useState(false);
  console.log(width);
  return (
    <div
      style={{
        width: width,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        backgroundColor: colors.bgSecondary,
      }}
    >
      <MenuDisplayHeader
        width={width}
        onLegalityClick={() => navigate("/legality")}
        selected={"about"}
        onPharmaciesClick={() => navigate("/pharmacies")}
        onPractionersClick={() => navigate("/practioner")}
        onSignUpClick={() => setSignUp(true)}
        onLogInClick={() => setLogin(true)}
        onContactClick={() => setContact(true)}
        height={height}
      />
      <div style={{ minHeight: 66 }} />
      <MainBanner onSignUpClick={() => setSignUp(true)} />
      <Welcome onSignUpClick={() => setSignUp(true)} />
      <InfoPanel onSignUpClick={() => setSignUp(true)} />
      <NearStore onContactClick={() => setContact(true)} />
      <Footer />
      <SignUpPopUp
        display={signUp}
        setClose={() => setSignUp(false)}
        width={width}
      />
      <LoginPopUp
        display={login}
        setClose={() => setLogin(false)}
        width={width}
      />
      <ContactUsPopUp display={contact} setClose={() => setContact(false)} />
    </div>
  );
};

export default LandingPage;
